import React, { useState, useEffect } from "react";
import classes from './MemebersPersonalLedger.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import {
    BarChart2,
    Filter,
    CalendarClock,
    Mail,
    ArrowLeft,
    Printer,
    Download,
    Settings
} from 'lucide-react';
import BackLogo from '../../Assets/assets/back.svg'
import Footer from "../../Components/Footer/Footer";

const MemeberPersonalLedger = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const {
  ledger,
  memberName,
  memberId,
 savingsType,
  totalDebit,
  totalCredit,
  totalBalance,
  totalSavings,
} = location.state || {};

    // Get customer data from navigation state
    const supplierName = location.state?.memberName || "Member Name"; // Keep as customerName for now since that's what you're passing
    const ledgers = location.state?.ledger || []; // Keep as customerName for now since that's what you're passing
    const totalBalances = location.state?.totalBalance || []; // Keep as customerName for now since that's what you're passing
    const supplierId = location.state?.customerId || null;
    const supplierDetails = location.state?.customerDetails || null;
    const filteredTransactions = location.state?.filteredInvoices || []; // These are actually supplier ledger entries
    const totalPurchases = location.state?.totalSales || 0; // Total purchases from supplier
    const totalPaid = location.state?.totalPaid || 0;
    const totalOutstanding = location.state?.totalOutstanding || 0;
    const totalInvoices = location.state?.totalInvoices || 0;
    // const ledger = location.state?.ledger || 0;
    const { member } = location.state;
    // console.log("full memebers", member );
    console.log("full ledger", ledgers );


    // Convert invoice data to ledger entries
    const [ledgerData, setLedgerData] = useState([]);

    // Helper functions for currency formatting
    const formatMoney = (value) => {
        const num = Number(value || 0);
        return num.toLocaleString("en-NG", { minimumFractionDigits: 2 });
    };

    const getPaymentStatus = (debtAmount, totalAmount) => {
        const debtNum = parseFloat(debtAmount || 0);
        const totalNum = parseFloat(totalAmount || 0);

        if (debtNum === 0) {
            return "Paid";
        } else if (debtNum === totalNum) {
            return "Owing";
        } else {
            return "Partial";
        }
    };

 


    const [selectedRows, setSelectedRows] = useState([]);
    const allSelected = selectedRows.length === ledgerData.length;

    const handleSelectAll = () => {
        if (allSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(ledgerData.map((_, i) => i));
        }
    };

    const handleSelectRow = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter(i => i !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    // Calculate running balance
    // (For suppliers: debit increases what we owe, credit decreases what we owe)
    let currentRunningTotal = 0;
    const dataWithRunningBalance = ledgers.map((row) => {
      const debitAmount = Number(row.debit || 0);
    const creditAmount = Number(row.credit || 0);
    // const balances = Number(row.balance || 0);

    // Calculate: Previous Balance + current Debit - current Credit
    currentRunningTotal = currentRunningTotal + creditAmount  - debitAmount;

    return {
        ...row,
        // Store numeric value for the Closing Balance calculation
        numericRunningBalance: currentRunningTotal, 
        // Format for display in the table
        runningBalance: formatMoney(currentRunningTotal)
    };
});
    // Get the last item to display the final Closing Balance
    const lastRow = dataWithRunningBalance[dataWithRunningBalance.length - 1];
  

    const totalBalancess = ledgers.reduce(
  (sum, item) => sum + Number(item.balance || 0),
  0
);

const period = (ledgers = []) => {
  if (!ledgers.length) {
    return {
      startDate: "",
      endDate: "",
    };
  }

  const dates = ledgers
    .map((item) => new Date(item.transaction_date))
    .sort((a, b) => a - b);

  const formatDate = (date) =>
    date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  return {
    startDate: formatDate(dates[0]),
    endDate: formatDate(dates[dates.length - 1]),
  };
};



const { startDate, endDate } = period(ledgers);
const userData = JSON.parse(localStorage.getItem('userData'));

    return (
        <div>
            <HeaderNav className={classes.headers} activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.backTxt}>
                    {/* <MoveLeft className={classes.iconBtn} onClick={() => navigate(-1)} /> */}
                    <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => navigate(-1)} />
                    <div className={classes.bckText}>
                        <h3 className={classes.topText}>Member's Saving Ledger </h3>
                        
                    </div>
                    <div className={classes.iconbarss}>
                                        {/* <div className={classes.iconbar}>
                                            <Mail size={16} />
                                        </div> */}
                                    <div
                                        className={classes.iconbar}
                                        onClick={() => window.print()}
                                        style={{ cursor: "pointer" }}
                                        >
                                        <Printer color='white' size={16} />
                                        </div>
                                        <div className={classes.iconbar}>
                                            <Download color='white' size={16} />
                                        </div>
                                        {/* <div className={classes.iconbar}>
                                            <Settings size={16} />
                                        </div> */}
                    </div>
                </div>
               
                <div className={classes.containere}>
                    {/* <div className={classes.divider}></div> */}
                    <header className={classes.headers}>
                        {/* <h1 className={classes.companyName}>REDEEMED CHRISTIAN CHURCH OF GOD</h1>
                        <h2 className={classes.title}>SUPPLIER'S PERSONAL LEDGER</h2>
                        <p className={classes.period}>For the period ended {new Date().toLocaleDateString()}</p> */}
                        <p className={classes.toplea}>
                            {userData?.company?.name}
                        </p>
                        <p className={classes.period}>Members' Saving Ledger - {""} {new Date().toLocaleDateString()}</p>
                        {/* <p className={classes.period}>Supplier's Ledger</p> */}
                        {/* <button className={classes.unaudited}>unaudited</button> */}
                    </header>

                <div className={classes.supplierInformation}>
                    <div className={classes.supplierInfo}>
                    <h1>Member Name: <span style={{fontWeight: 400}}> {supplierName}</span></h1>
                    <h1 style={{marginTop: "0px"}}>Address: <span style={{fontWeight: 400}}> {member?.address}</span></h1>
                    <h1 style={{marginTop: "0px"}}>Phone: <span style={{fontWeight: 400}}> {member?.phone_number}</span></h1>
            </div>
                <div className={classes.ledgerInfo}>
                <h1>
            Ledger Period:{" "}
            <span style={{ fontWeight: 400 }}>
            {startDate} - {endDate}
            </span>
            </h1>
                <h1 style={{marginTop: "0px"}}>
            Opening Balance:{" "}
            <span style={{ fontWeight: 400 }}>
                {/* {Number(ledgers?.[0]?.balance || 0).toLocaleString(
                "en-NG",
                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                )} */}
                ₦0.00
            </span>
            </h1>
                
                

            </div>
                </div>    
                    {/* Table Container */}
                    <div className={classes.tableContainer}>
                        <table className={classes.table}>
                            <thead>
                                <tr className={classes.tableHeader}>
                                    <th>DATE</th>
                                    <th>REF NO</th>
                                    <th>DESCRIPTION</th>
                                    <th style={{ textAlign: 'right' }}>DEBIT (₦)</th>
                                    <th style={{ textAlign: 'right' }}>CREDIT (₦)</th>
                                    <th style={{ textAlign: 'right' }}>BALANCE (₦)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataWithRunningBalance.length > 0 ? (
                                    dataWithRunningBalance.map((row, index) => 
                                        <tr key={row.id || index} className={classes.tableRow}>
                                            <td className={classes.tableCell}>{row.transaction_date}</td>
                                                <td className={classes.tableCell}>
                                            {row.uuid}
                                            </td>
                                            <td className={classes.tableCell} >{row.description ||  "0"}</td>
                                            
                                            <td style={{ 
                                                // color: 'rgba(220, 38, 38, 1)', 
                                            textAlign: 'right' }}>
                                                {row.debit
                                                ? formatMoney(row.debit)
                                                : "0.00"}
                                            </td>
                                            <td style={{ 
                                                // color: 'rgba(22, 163, 74, 1)', 
                                                textAlign: 'right' }}>
                                                {row.credit
                                                ? formatMoney(row.credit)
                                                : "0.00"}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                            {/* {row.balance
                                                ? formatMoney(row.balance)
                                                : "0.00"} */}
                                            {/* {row.runningBalance
                                                ? formatMoney(row.runningBalance)
                                                : "0.00"} */}
                                                {row.runningBalance || "0.00"}
                                                </td>
                                        </tr>
                                    )
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                                            No transactions found for {supplierName}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                        <div className={classes.closingBalance}>
                            <h1 style={{fontSize: 18}}>
                            Closing Balance: ₦
                        {/* {totalBalancess
                                    ? formatMoney(totalBalancess)
                                    : "0.00"} */}
                                        {lastRow
                                    ? formatMoney(lastRow.numericRunningBalance)
                                    : "0.00"}
                        </h1>
                        </div>

                    {/* Summary Footer */}

                    {/* Footer Table */}
                    {/* <table className={classes.footerTable}>
                        <tfoot>
                            <tr>
                                <td className={classes.frston}>First</td>
                                <td className={`${classes.page} ${classes.activePage}`}>1</td>
                                <td className={classes.twono}>2</td>
                                <td className={classes.lastno}>Last</td>
                            </tr>
                        </tfoot>
                    </table> */}

                    {/* <div className={classes.lasone}>
                        <div className={classes.paginationDisplay}>
                            Displaying 1 - {dataWithRunningBalance.length} of {dataWithRunningBalance.length}
                        </div>
                    </div> */}
                </div>
            </div>
            <Footer className={classes.footers} />
        </div>
    );
};

export default MemeberPersonalLedger;